import { ReactNode, ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface AIMButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary';
  children: ReactNode;
}

export function AIMButton({
  variant = 'default',
  children,
  className,
  ...props
}: AIMButtonProps) {
  return (
    <button
      className={cn(
        variant === 'primary' ? 'aim-button-primary' : 'aim-button',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
